import Agente from "../models/Agente";

export default class SessionStorageUtilities {
    static TENANT_SESSION = 'org';
    static CURRENT_AGENT_SESSION = 'currentAgent';
    static GO_LOGIN_SESSION = 'goLogin';

    /**
     *
     * @returns {string}
     */
    static GET_TENANT_SESSION() {
        return sessionStorage.getItem(SessionStorageUtilities.TENANT_SESSION);
    }

    /**
     *
     * @returns {string}
     */
    static GET_USER_AGENT_SESSION() {
        return sessionStorage.getItem(SessionStorageUtilities.CURRENT_AGENT_SESSION);
    }

    /**
     *
     * @param {(Agente|Object|Array|string)} agente
     * @constructor
     */
    static SET_USER_AGENT_SESSION(agente) {
        if(agente instanceof Agente) {
            agente = agente.toJson();
        }

        if(Array.isArray(agente) || agente instanceof Object || typeof agente === 'object') {
            agente = JSON.stringify(agente);
        }

        return sessionStorage.setItem(SessionStorageUtilities.CURRENT_AGENT_SESSION, agente);
    }

    /**
     *
     * @returns {string}
     */
    static GET_GO_LOGIN_SESSION() {
        return sessionStorage.getItem(SessionStorageUtilities.GO_LOGIN_SESSION);
    }

    /**
     *
     */
    static DELETE_GO_LOGIN_SESSION() {
        return sessionStorage.removeItem(SessionStorageUtilities.GO_LOGIN_SESSION);
    }

    static CLEAR() {
        return sessionStorage.clear();
    }
}